import request from "@/utils/request";
import { getLogionUserInfo } from "@/utils/auth"; // 验权


/**
 * 代理商配置列表
 * @param params
 * @returns {AxiosPromise}
 */
export function getAgentConfig(params) {
  return request({
    url: "/agentOrder/getAgentConfig",
    method: "get",
    params
  });
}

/**
 * 代理商管理列表
 * @param data
 * @returns {*}
 */
export function getAgentList(data) {
  return request({
    url: "/agentOrder/getAgentList",
    method: "post",
    data,
    headers: {
      "Content-Type": "application/json"
    }
  });
}
